/**
 * Indicates an error that should trigger a retry attempt in SSE connections
 */
export class RetriableError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'RetriableError';
  }
}
